<template>
  <div>
    <admin-nav active="templates" />
    <b-container fluid>
      <b-row class="mb-1">
        <b-col>
          <h3>Templates PDF</h3>
          <small class="text-muted">
            Modèles vierges utilisés par les générateurs de PDF du parcours
            de domiciliation. Toute mise à jour est immédiatement appliquée.
            Pour les contrats, les positions des placeholders sont
            ré-extraites automatiquement après upload.
          </small>
        </b-col>
        <b-col class="text-right">
          <b-button
            variant="outline-primary"
            :disabled="regenLoading"
            @click="regenPlaceholders"
          >
            <b-spinner
              v-if="regenLoading"
              small
            />
            <feather-icon
              v-else
              icon="RefreshCwIcon"
            />
            Recalculer les placeholders
          </b-button>
        </b-col>
      </b-row>

      <h5 class="mt-2">
        Modèles principaux
      </h5>
      <b-table
        :items="principaux"
        :fields="fields"
        striped
        responsive
      >
        <template #cell(taille)="row">
          {{ formatTaille(row.item.taille) }}
        </template>
        <template #cell(datemaj)="row">
          {{ formatDate(row.item.datemaj) }}
        </template>
        <template #cell(actions)="row">
          <b-button
            size="sm"
            variant="outline-primary"
            class="mr-1"
            @click="telecharger(row.item)"
          >
            <feather-icon icon="DownloadIcon" /> Télécharger
          </b-button>
          <b-form-file
            v-model="uploadFiles[row.item.filename]"
            class="d-inline-block"
            style="width: 280px;"
            placeholder="Remplacer (PDF)"
            accept="application/pdf"
            size="sm"
            @input="uploader(row.item, $event)"
          />
        </template>
      </b-table>

      <h5 class="mt-3">
        Visuels packs &amp; COWORKING
      </h5>
      <b-table
        :items="visuels"
        :fields="fields"
        striped
        responsive
      >
        <template #cell(taille)="row">
          {{ formatTaille(row.item.taille) }}
        </template>
        <template #cell(datemaj)="row">
          {{ formatDate(row.item.datemaj) }}
        </template>
        <template #cell(actions)="row">
          <b-button
            size="sm"
            variant="outline-primary"
            class="mr-1"
            @click="telecharger(row.item)"
          >
            <feather-icon icon="DownloadIcon" /> Télécharger
          </b-button>
          <b-form-file
            v-model="uploadFiles[row.item.filename]"
            class="d-inline-block"
            style="width: 280px;"
            placeholder="Remplacer (PDF)"
            accept="application/pdf"
            size="sm"
            @input="uploader(row.item, $event)"
          />
        </template>
      </b-table>
    </b-container>
  </div>
</template>

<script>
import {
  BContainer,
  BRow,
  BCol,
  BButton,
  BTable,
  BFormFile,
  BSpinner,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import AdminNav from './AdminNav.vue'

export default {
  components: {
    BContainer,
    BRow,
    BCol,
    BButton,
    BTable,
    BFormFile,
    BSpinner,
    AdminNav,
  },
  data() {
    return {
      principaux: [],
      visuels: [],
      uploadFiles: {},
      regenLoading: false,
      fields: [
        { key: 'filename', label: 'Fichier' },
        { key: 'taille', label: 'Taille' },
        { key: 'datemaj', label: 'Modifié le' },
        { key: 'actions', label: '' },
      ],
    }
  },
  created() {
    this.charger()
  },
  methods: {
    authHeaders() {
      return { headers: { 'x-access-token': localStorage.getItem('domAdminToken') } }
    },
    apiBase() {
      return process.env.VUE_APP_APIURL || 'https://api.reunibox.com/'
    },
    formatTaille(o) {
      if (!o) return '—'
      if (o < 1024) return `${o} o`
      if (o < 1024 * 1024) return `${(o / 1024).toFixed(1)} Ko`
      return `${(o / (1024 * 1024)).toFixed(2)} Mo`
    },
    formatDate(d) {
      if (!d) return '—'
      return new Date(d).toLocaleString('fr-FR')
    },
    charger() {
      this.$http.get('/admindom/templates', this.authHeaders())
        .then(response => {
          if (response.data.res === 1) {
            this.principaux = response.data.principaux
            this.visuels = response.data.visuels
          }
        })
    },
    telecharger(item) {
      const url = `/admindom/templates/${encodeURIComponent(item.filename)}`
      this.$http.get(url, { ...this.authHeaders(), responseType: 'blob' })
        .then(response => {
          const blob = new Blob([response.data], { type: 'application/pdf' })
          const objUrl = URL.createObjectURL(blob)
          const a = document.createElement('a')
          a.href = objUrl
          a.download = item.filename
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
          URL.revokeObjectURL(objUrl)
        })
    },
    uploader(item, file) {
      if (!file) return
      if (file.type !== 'application/pdf') {
        this.toast('Le fichier doit être un PDF', 'danger', 'AlertTriangleIcon')
        this.$set(this.uploadFiles, item.filename, null)
        return
      }
      const formData = new FormData()
      formData.append('file', file)
      this.$http.post(`/admindom/templates/${encodeURIComponent(item.filename)}`, formData, {
        headers: {
          'x-access-token': localStorage.getItem('domAdminToken'),
          'Content-Type': 'multipart/form-data',
        },
      })
        .then(response => {
          if (response.data.res === 1) {
            this.toast(response.data.message || 'Template mis à jour', 'success', 'CheckIcon')
            this.$set(this.uploadFiles, item.filename, null)
            this.charger()
          } else {
            this.toast(response.data.message || "Erreur d'upload", 'danger', 'AlertTriangleIcon')
          }
        })
        .catch(err => {
          this.toast(err.response && err.response.data ? err.response.data.message : "Erreur d'upload", 'danger', 'AlertTriangleIcon')
        })
    },
    regenPlaceholders() {
      this.regenLoading = true
      this.$http.post('/admindom/templates/regen-placeholders', {}, this.authHeaders())
        .then(response => {
          this.regenLoading = false
          if (response.data.res === 1) {
            this.toast('Placeholders recalculés', 'success', 'CheckIcon')
            this.charger()
          } else {
            this.toast(response.data.message || 'Erreur', 'danger', 'AlertTriangleIcon')
          }
        })
        .catch(() => {
          this.regenLoading = false
          this.toast('Erreur lors du recalcul', 'danger', 'AlertTriangleIcon')
        })
    },
    toast(title, variant, icon) {
      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: { title, variant, icon },
      })
    },
  },
}
</script>
